import { Host } from 'hooks';

export const getRowId = (data: Host): string => data.id.toString();
